import { AppThunk } from '../../../../../store/types';
import { UserRest } from '../../../../../../common/rest/user/userRest';
import { ADMIN_PANEL_URL } from '../../../../../../common/constants';
import { getCurrentVideoKey } from '../../../../../store/current-video/selectors';

export class MenuButtonEditVideoEvents {

  public static onClick(): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const videoId = getCurrentVideoKey(getState());
      if (videoId) {
        await UserRest.loginAdmin();
        window.open(`${ADMIN_PANEL_URL}video/${videoId}`);
      }
    }
  }

}
